import React from "react";
import { Form } from "react-bootstrap";

const Loader = () => {
  return (
    <Form
      as="div"
      className="text-dark loading-container position-fixed   w-100 h-50 bg-white d-flex justify-content-center align-items-center"
      style={{ zIndex: "9999" }}
    >
      <Form as="span" className="loading-component"></Form>
    </Form>
  );
};

export default Loader;
